/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { TOPOLOGY_ROOM } from "../RoomNameConstants";

const state = {
    ID: TOPOLOGY_ROOM,
    isManipulable: {
        stateName: "graph",
        settings: {
            selected: null,
            enabled: {
                VR: ["rotation", "zoom"],
                desktop: ["rotation", "zoom"]
            },
        },
    },
    graph: {
        data: {
            nodes: [],
            links: [],
        },
        state: {
            scale: 1,
            rotation: { x: 0, y: 0, z: 0 },
            position: { x: 0, y: 0, z: 0 },
        },
        pollingDelay: 30,
        title: "Jobstream",
        filter: ["Error", "Waiting", "Successful", "Running"],
        currentHoverElement: null,
    }
};

export default state;
